import { AsyncUtility } from "../utilities/AsyncUtility";

export class CachedDataAccessor<TInstance, TData> {
  constructor(private _createCache: (i: TInstance) => Promise<TData>) {
    this.clearCache();
  }

  clearCache() {
    this._shouldCreateCache = true;
    this._result = null;
    this._cache = undefined;
  }

  private _shouldCreateCache: boolean;
  private _result: boolean ;
  private _cache: TData;

  private async createCache(instance: TInstance): Promise<void> {
    try {
      if (this._shouldCreateCache) {
        this._shouldCreateCache = false;
        this._cache = await this._createCache(instance);
        this._result = true;
      } else if (this._result === null) {
        await AsyncUtility.wait(() => this._result !== null);
      }
    } catch {
      this._result = false;
    }
  }

  async getData(instance: TInstance): Promise<TData> {
    while (this._result !== true) {
      await this.createCache(instance);
    }
    return this._cache;
  }
}
